import { render, staticRenderFns } from "./TableRecords.vue?vue&type=template&id=05438dcc"
import script from "./TableRecords.vue?vue&type=script&lang=js"
export * from "./TableRecords.vue?vue&type=script&lang=js"
import style0 from "./TableRecords.vue?vue&type=style&index=0&id=05438dcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports